
import { AmmunitionStockMetadataBase } from './ammunition-stock.metadata.base';


export class AmmunitionStockMetadata extends AmmunitionStockMetadataBase {
  constructor() {
    super();
  }
}

export const AMMUNITION_STOCK_METADATA: AmmunitionStockMetadata = new AmmunitionStockMetadata();


